// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 对齐方式枚举 枚举类
 * 对齐方式枚举
 */
export enum EnumAlignStyle {
  /** 居左对齐 : 居左对齐 */
  Left = 1,
  /** 居中对齐 : 居中对齐 */
  Center = 2,
  /** 居右对齐 : 居右对齐 */
  Right = 4
}

/**
 * 对齐方式枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumAlignStyleMD {
  private static items = [
    new EnumItemMD('Left', 1, '居左对齐', '居左对齐'),
    new EnumItemMD('Center', 2, '居中对齐', '居中对齐'),
    new EnumItemMD('Right', 4, '居右对齐', '居右对齐')
  ];

  static getItem(enumItem: EnumAlignStyle) {
    return this.items.find(item => item.name === EnumAlignStyle[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
